import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import { QuickSearchChannelItem } from '@fc-search/models/quick-search';
import { QuickSearchFacadeService } from '@fc-search/services/quick-search-facade.service';
import { ButtonComponent } from '@fc-shared/ui/buttons/button.component';
import { TooltipDirective } from '@fc-shared/ui/tooltips/tooltip.directive';

@Component({
  selector: 'fc-qs-channel-result',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, IconComponent, ButtonComponent, TooltipDirective],
  template: `
    <div
      class="flex gap-12 items-center max-w-full relative py-8 pl-14 pr-16 hover:bg-secondary-50 cursor-pointer group border-l-2"
      [class.border-white]="!selected()"
      [class.border-primary-600]="selected()"
      [class.bg-secondary-50]="selected()"
      [routerLink]="['/chats/direct-message', result().obj.id]"
    >
      <div
        class="size-40 shrink-0 rounded-xl bg-secondary-100 flex items-center justify-center"
      >
        <fc-icon icon="icon-chats-bold" color="secondary600" [size]="20" />
      </div>

      <div class="flex flex-col gap-4 grow min-w-0">
        <span class="text-sm font-medium text-grey-900 truncate">
          {{ result().obj.name || result().obj.memberNames?.[1] }}
        </span>
        <div
          class="flex flex-wrap items-center gap-4 text-xs font-medium text-secondary-500 truncate"
        >
          <span>Group channel</span>
        </div>
      </div>
      <div
        class="gap-4 p-4 rounded-xl bg-white border-secondary-100 shadow-sm"
        [class.opacity-0]="!selected()"
        [class.opacity-100]="selected()"
        [class.group-hover:opacity-100]="!selected()"
      >
        <div
          fcTooltip="Open in new tab"
          [showTooltip]="selected() && activeButtonIndex() === 0"
        >
          <fc-button
            variant="filled"
            color="primary"
            [focused]="activeButtonIndex() === 0"
            icon="icon-new-window"
            size="sm"
            iconPosition="only"
            (click)="viewDetails(); $event.stopPropagation()"
          />
        </div>
      </div>
    </div>
  `,
})
export class QsChannelResultComponent {
  result = input.required<QuickSearchChannelItem>();
  selected = input(false);
  activeButtonIndex = input(-1);
  quickAction = output();
  private router = inject(Router);
  private facade = inject(QuickSearchFacadeService);

  viewDetails(): void {
    this.quickAction.emit();
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/chats/direct-message/' + this.result().obj.id,
      ]),
    );
    window.open(url, '_blank');
    this.facade.clearAndClose();
  }

  activateButton(index: number): void {
    if (index === 0) {
      this.viewDetails();
    }
  }
}
